import type { ISanitizeOptions } from "@frontiers-vue3/public-pages";

export const RESEARCH_TOPIC_TITLE_ALLOWED_TAGS = [
  "sub",
  "sup",
  "i",
  "em"
] as const;

type SanitizeFn = (html: string, options?: ISanitizeOptions) => string;

export function sanitizeResearchTopicTitle(
  sanitize: SanitizeFn,
  title?: string | null
): string {
  return sanitize(title || "", {
    ALLOWED_TAGS: [...RESEARCH_TOPIC_TITLE_ALLOWED_TAGS]
  });
}
